/*
  STRICT COMPACT "CHOOSE OPTIONS" POPUP
  Shopify Dawn — replace the complete contents of:
  Assets > quick-add.js

  This version shows ONLY:
  - available color, size, and other variant choices
  - quantity
  - Add to cart
  - the modal close button

  EASY SETTINGS
*/
const COMPACT_QUICK_ADD_SETTINGS = {
  // Space above a fixed mobile footer or bottom navigation.
  // Change to '0rem' when your store has no fixed bottom bar.
  mobileFooterClearance: '0rem',

  // Popup dimensions.
  desktopPopupWidth: '420px',
  desktopPopupMaxHeight: '78dvh',
  mobileSideSpace: '14px',
  mobilePopupMaxWidth: '390px',
  mobilePopupMaxHeight: '84dvh',

  // Hide sold-out or unavailable option values.
  hideUnavailableOptions: true,
};

(() => {
  const STYLE_ID = 'strict-compact-quick-add-styles';

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/([^\w-])/g, '\\$1');
  };

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const settings = COMPACT_QUICK_ADD_SETTINGS;
    const style = document.createElement('style');

    style.id = STYLE_ID;
    style.textContent = `
      quick-add-modal.strict-compact-quick-add {
        --compact-mobile-footer-clearance: ${settings.mobileFooterClearance};
        --compact-desktop-width: ${settings.desktopPopupWidth};
        --compact-desktop-max-height: ${settings.desktopPopupMaxHeight};
        --compact-mobile-side-space: ${settings.mobileSideSpace};
        --compact-mobile-max-width: ${settings.mobilePopupMaxWidth};
        --compact-mobile-max-height: ${settings.mobilePopupMaxHeight};
      }

      quick-add-modal.strict-compact-quick-add[open] {
        z-index: 2147483000;
      }

      quick-add-modal.strict-compact-quick-add .quick-add-modal__content {
        top: 50%;
        left: 50%;
        width: min(var(--compact-desktop-width), calc(100% - 3rem));
        max-width: var(--compact-desktop-width);
        max-height: var(--compact-desktop-max-height);
        margin: 0;
        overflow: hidden;
        border-radius: 1.2rem;
        transform: translate(-50%, -50%);
        box-shadow: 0 1.8rem 5rem rgba(0, 0, 0, 0.24);
      }

      quick-add-modal.strict-compact-quick-add .quick-add-modal__content-info {
        display: block;
        width: 100%;
        height: auto;
        max-height: var(--compact-desktop-max-height);
        padding: 2.4rem;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
      }

      quick-add-modal.strict-compact-quick-add .quick-add-modal__toggle {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 3.8rem;
        height: 3.8rem;
        padding: 1rem;
      }

      quick-add-modal.strict-compact-quick-add product-info,
      quick-add-modal.strict-compact-quick-add product-component,
      quick-add-modal.strict-compact-quick-add .page-width,
      quick-add-modal.strict-compact-quick-add .product,
      quick-add-modal.strict-compact-quick-add .product__info-wrapper,
      quick-add-modal.strict-compact-quick-add .product__info-container {
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 0;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quick-add__body {
        display: grid;
        gap: 1.8rem;
        padding-top: 2.8rem;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quick-add__price {
        display: block !important;
        margin: 0;
        padding: 0;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quick-add__price .price {
        margin: 0;
        font-size: 1.8rem;
        font-weight: 700;
      }

      quick-add-modal.strict-compact-quick-add variant-selects {
        display: grid;
        gap: 1.5rem;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input {
        max-width: none;
        margin: 0;
        padding: 0;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input .form__label,
      quick-add-modal.strict-compact-quick-add .quantity__label {
        display: block;
        margin-bottom: 0.8rem;
        font-weight: 600;
      }

      /*
        Keep option choices compact. Dawn places the radio input and its
        label beside each other, so the input is removed from the grid flow
        and every visible choice occupies one of two equal columns.
      */
      quick-add-modal.strict-compact-quick-add .product-form__input--pill,
      quick-add-modal.strict-compact-quick-add .product-form__input--swatch {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.8rem;
        width: 100%;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input--pill legend,
      quick-add-modal.strict-compact-quick-add .product-form__input--swatch legend,
      quick-add-modal.strict-compact-quick-add .product-form__input--pill .form__label,
      quick-add-modal.strict-compact-quick-add .product-form__input--swatch .form__label {
        grid-column: 1 / -1;
        width: 100%;
        margin: 0 0 0.2rem;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input--pill input[type='radio'],
      quick-add-modal.strict-compact-quick-add .product-form__input--swatch input[type='radio'] {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
        clip-path: inset(50%) !important;
        white-space: nowrap !important;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input--pill input[type='radio'] + label,
      quick-add-modal.strict-compact-quick-add .product-form__input--swatch .swatch-input__label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 0;
        min-height: 4.4rem;
        margin: 0;
        padding: 0.7rem 0.8rem;
        text-align: center;
        box-sizing: border-box;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input--swatch .swatch-input__label {
        gap: 0.6rem;
      }

      quick-add-modal.strict-compact-quick-add .product-form__input--swatch .swatch {
        flex: 0 0 auto;
        width: 2.8rem;
        height: 2.8rem;
        border-radius: 50%;
      }

      quick-add-modal.strict-compact-quick-add .product-form__quantity {
        margin: 0;
      }

      quick-add-modal.strict-compact-quick-add .product-form__quantity .price-per-item__container {
        display: block;
      }

      quick-add-modal.strict-compact-quick-add .product-form__quantity .quantity__rules,
      quick-add-modal.strict-compact-quick-add .product-form__quantity .quantity__rules-cart,
      quick-add-modal.strict-compact-quick-add .product-form__quantity volume-pricing,
      quick-add-modal.strict-compact-quick-add .product-form__quantity price-per-item {
        display: none !important;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity {
        display: grid;
        gap: 0.8rem;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__label {
        font-weight: 600;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__control {
        display: grid;
        grid-template-columns: 4.4rem minmax(6rem, 9rem) 4.4rem;
        width: fit-content;
        overflow: hidden;
        border: 0.1rem solid rgba(var(--color-foreground), 0.22);
        border-radius: var(--inputs-radius);
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__button,
      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__input {
        min-height: 4.4rem;
        color: rgb(var(--color-foreground));
        background: rgb(var(--color-background));
        border: 0;
        font: inherit;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__button {
        cursor: pointer;
        font-size: 2rem;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__input {
        width: 100%;
        padding: 0 0.5rem;
        text-align: center;
        appearance: textfield;
      }

      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__input::-webkit-inner-spin-button,
      quick-add-modal.strict-compact-quick-add .strict-compact-quantity__input::-webkit-outer-spin-button {
        margin: 0;
        appearance: none;
      }

      quick-add-modal.strict-compact-quick-add product-form {
        display: block;
      }

      quick-add-modal.strict-compact-quick-add .product-form__buttons {
        max-width: none;
      }

      quick-add-modal.strict-compact-quick-add .product-form__submit {
        min-height: 4.8rem;
        margin: 0;
      }

      /*
        Last-resort protection:
        hide every normal product-page element that should never appear
        inside this strict popup.
      */
      quick-add-modal.strict-compact-quick-add .product__media-wrapper,
      quick-add-modal.strict-compact-quick-add .product__title,
      quick-add-modal.strict-compact-quick-add .product__text,
      quick-add-modal.strict-compact-quick-add .product__description,
      quick-add-modal.strict-compact-quick-add .product__tax,
      quick-add-modal.strict-compact-quick-add .product__accordion,
      quick-add-modal.strict-compact-quick-add .product-popup-modal__opener,
      quick-add-modal.strict-compact-quick-add .product__social-sharing,
      quick-add-modal.strict-compact-quick-add .shopify-payment-button,
      quick-add-modal.strict-compact-quick-add .recipient-form,
      quick-add-modal.strict-compact-quick-add .product__view-details,
      quick-add-modal.strict-compact-quick-add pickup-availability,
      quick-add-modal.strict-compact-quick-add [id^='Inventory-'],
      quick-add-modal.strict-compact-quick-add [id^='Sku-'],
      quick-add-modal.strict-compact-quick-add [id^='Volume-'] {
        display: none !important;
      }

      @media screen and (max-width: 749px) {
        quick-add-modal.strict-compact-quick-add {
          top: 0;
          bottom: 0;
          height: 100dvh;
        }

        quick-add-modal.strict-compact-quick-add .quick-add-modal__content {
          top: 50%;
          bottom: auto;
          width: calc(100% - (var(--compact-mobile-side-space) * 2));
          max-width: var(--compact-mobile-max-width);
          max-height: var(--compact-mobile-max-height);
          border-radius: 1.2rem;
          transform: translate(-50%, -50%);
        }

        quick-add-modal.strict-compact-quick-add .quick-add-modal__content-info {
          max-height: var(--compact-mobile-max-height);
          padding: 1.5rem 1.5rem calc(1.7rem + env(safe-area-inset-bottom));
        }

        quick-add-modal.strict-compact-quick-add .strict-compact-quick-add__body {
          gap: 1.4rem;
          padding-top: 3rem;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const optionTextLooksUnavailable = (option) => {
    if (option.disabled) return true;

    const text = option.textContent.trim().toLowerCase();
    const translatedUnavailable = String(
      window.variantStrings?.unavailable || ''
    )
      .trim()
      .toLowerCase();

    const translatedSoldOut = String(
      window.variantStrings?.soldOut || ''
    )
      .trim()
      .toLowerCase();

    return (
      text.includes('unavailable') ||
      text.includes('not available') ||
      text.includes('sold out') ||
      (translatedUnavailable && text.includes(translatedUnavailable)) ||
      (translatedSoldOut && text.includes(translatedSoldOut))
    );
  };

  if (!customElements.get('quick-add-modal')) {
    customElements.define(
      'quick-add-modal',
      class StrictCompactQuickAddModal extends ModalDialog {
        constructor() {
          super();

          addStyles();

          this.classList.add('strict-compact-quick-add');
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

          /*
            Dawn sends future variant-picker HTML through this callback.
            Filtering here keeps unavailable options hidden after every
            color, size, or other option change.
          */
          this.addEventListener('product-info:loaded', ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });

          this.addEventListener(
            'click',
            this.onFallbackQuantityClick.bind(this)
          );
        }

        hide(preventFocus = false) {
          const cartUI =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');

          if (cartUI) {
            cartUI.setActiveElement(this.openedBy);
          }

          this.modalContent.innerHTML = '';

          if (preventFocus) {
            this.openedBy = null;
          }

          super.hide();
        }

        show(opener) {
          const productUrl = opener.getAttribute('data-product-url');
          const spinner = opener.querySelector('.loading__spinner');

          if (!productUrl) return;

          opener.setAttribute('aria-disabled', 'true');
          opener.classList.add('loading');
          spinner?.classList.remove('hidden');

          fetch(productUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(
                  `Quick-add request failed: ${response.status}`
                );
              }

              return response.text();
            })
            .then((responseText) => {
              const responseHTML = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

              const productElement =
                responseHTML.querySelector('product-info');

              if (!productElement) {
                throw new Error(
                  'The product information section was not found.'
                );
              }

              this.preprocessHTML(productElement);

              HTMLUpdateUtility.setInnerHTML(
                this.modalContent,
                productElement.outerHTML
              );

              this.modalContent
                .querySelector('product-component')
                ?.dispatchViewEvent?.();

              super.show(opener);
            })
            .catch((error) => {
              console.error('[Strict compact quick add]', error);
            })
            .finally(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              spinner?.classList.add('hidden');
            });
        }

        preprocessHTML(root) {
          if (!root) return;

          /*
            During a variant change Dawn passes only variant-selects here.
          */
          if (root.matches?.('variant-selects')) {
            this.removeUnavailableOptions(root);
            return;
          }

          this.copyColorScheme(root);
          this.preventDuplicatedIDs(root);
          this.preventVariantURLSwitching(root);
          this.buildStrictCompactProduct(root);
        }

        copyColorScheme(productElement) {
          this.modalContent.classList.forEach((className) => {
            if (
              className.startsWith('color-') ||
              className === 'gradient'
            ) {
              this.modalContent.classList.remove(className);
            }
          });

          productElement.classList.forEach((className) => {
            if (
              className.startsWith('color-') ||
              className === 'gradient'
            ) {
              this.modalContent.classList.add(className);
            }
          });
        }

        preventVariantURLSwitching(productElement) {
          productElement.setAttribute('data-update-url', 'false');
        }

        preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;

          if (!sectionId) return;

          const newSectionId = `quickadd-${sectionId}`;

          productElement.innerHTML =
            productElement.innerHTML.replaceAll(
              sectionId,
              newSectionId
            );

          Array.from(productElement.attributes).forEach(
            (attribute) => {
              if (attribute.value.includes(sectionId)) {
                productElement.setAttribute(
                  attribute.name,
                  attribute.value.replace(
                    sectionId,
                    newSectionId
                  )
                );
              }
            }
          );

          productElement.dataset.originalSection = sectionId;
        }

        buildStrictCompactProduct(productElement) {
          const variantPicker =
            productElement.querySelector('variant-selects');

          const quantityBlock =
            productElement.querySelector(
              '[id^="Quantity-Form-"], .product-form__quantity'
            );

          const productForm =
            productElement.querySelector('product-form');


          const priceBlocks = Array.from(
            productElement.querySelectorAll('[id^="price-"]')
          );

          const priceBlock = priceBlocks.find((element) => {
            return element.querySelector('.price') || element.classList.contains('price');
          }) || priceBlocks[0] || null;

          priceBlocks.forEach((element) => {
            if (element !== priceBlock) element.remove();
          });

          if (priceBlock) {
            priceBlock.classList.add('strict-compact-quick-add__price');
          }

          if (!productForm) {
            throw new Error(
              'The Dawn Add to cart form was not found.'
            );
          }

          if (
            COMPACT_QUICK_ADD_SETTINGS.hideUnavailableOptions
          ) {
            this.removeUnavailableOptions(variantPicker);
          }

          this.cleanQuantityBlock(quantityBlock);
          this.cleanProductForm(productForm);

          const compactBody =
            document.createElement('div');

          compactBody.className =
            'strict-compact-quick-add__body';

          if (priceBlock) {
            compactBody.appendChild(priceBlock);
          }

          if (variantPicker) {
            compactBody.appendChild(variantPicker);
          }

          if (quantityBlock) {
            compactBody.appendChild(quantityBlock);
          } else {
            const fallbackQuantity =
              this.createFallbackQuantity(productForm);

            if (fallbackQuantity) {
              compactBody.appendChild(fallbackQuantity);
            }
          }

          compactBody.appendChild(productForm);

          const infoContainer =
            document.createElement('section');

          infoContainer.className =
            'product__info-container';

          infoContainer.appendChild(compactBody);

          const infoWrapper =
            document.createElement('div');

          infoWrapper.className =
            'product__info-wrapper grid__item';

          infoWrapper.appendChild(infoContainer);

          const productShell =
            document.createElement('div');

          productShell.className =
            'product strict-compact-quick-add__product';

          productShell.appendChild(infoWrapper);

          const pageWidth =
            document.createElement('div');

          pageWidth.className = 'page-width';
          pageWidth.appendChild(productShell);

          const productComponent =
            productElement.querySelector('product-component');

          if (productComponent) {
            productComponent.replaceChildren(pageWidth);
          } else {
            /*
              Preserve stylesheet and script dependencies when a modified
              Dawn theme does not include product-component.
            */
            const dependencies = Array.from(
              productElement.children
            ).filter((element) =>
              ['LINK', 'STYLE', 'SCRIPT'].includes(
                element.tagName
              )
            );

            productElement.replaceChildren(
              ...dependencies,
              pageWidth
            );
          }
        }

        cleanQuantityBlock(quantityBlock) {
          if (!quantityBlock) return;

          quantityBlock
            .querySelectorAll(
              [
                '.quantity__rules',
                '.quantity__rules-cart',
                'volume-pricing',
                'price-per-item',
                '.price-per-item',
              ].join(', ')
            )
            .forEach((element) => element.remove());
        }

        cleanProductForm(productForm) {
          const form =
            productForm.querySelector('form');

          const variantInput =
            form?.querySelector('input[name="id"]');

          const submitButton =
            form?.querySelector(
              'button[type="submit"][name="add"], button[type="submit"]'
            );

          if (!form || !variantInput || !submitButton) {
            throw new Error(
              'The Dawn variant input or Add to cart button was not found.'
            );
          }

          productForm
            .querySelectorAll(
              [
                '.shopify-payment-button',
                '.recipient-form',
                'pickup-availability',
              ].join(', ')
            )
            .forEach((element) => element.remove());

          const buttons =
            document.createElement('div');

          buttons.className = 'product-form__buttons';
          buttons.appendChild(submitButton);

          form.replaceChildren(
            variantInput,
            buttons
          );

          productForm.replaceChildren(form);
        }

        removeUnavailableOptions(root) {
          if (
            !root ||
            !COMPACT_QUICK_ADD_SETTINGS.hideUnavailableOptions
          ) {
            return;
          }

          root
            .querySelectorAll(
              [
                'input[type="radio"].disabled',
                'input[type="radio"].visually-disabled',
                'input[type="radio"][disabled]',
                '.swatch-input__input.visually-disabled',
                '.swatch-input__input[disabled]',
              ].join(', ')
            )
            .forEach((input) => {
              const inputId = input.id;

              if (inputId) {
                root
                  .querySelector(
                    `label[for="${escapeSelector(inputId)}"]`
                  )
                  ?.remove();
              }

              input.remove();
            });

          root
            .querySelectorAll(
              '.product-form__input--dropdown select option'
            )
            .forEach((option) => {
              if (optionTextLooksUnavailable(option)) {
                option.remove();
              }
            });

          root.querySelectorAll('fieldset').forEach(
            (fieldset) => {
              const availableInputs =
                fieldset.querySelectorAll(
                  'input[type="radio"], .swatch-input__input'
                );

              if (!availableInputs.length) {
                fieldset.remove();
              }
            }
          );

          root
            .querySelectorAll(
              '.product-form__input--dropdown select'
            )
            .forEach((select) => {
              if (!select.options.length) {
                select
                  .closest(
                    '.product-form__input--dropdown'
                  )
                  ?.remove();
              }
            });
        }

        createFallbackQuantity(productForm) {
          const form =
            productForm.querySelector('form');

          if (!form?.id) return null;

          const wrapper =
            document.createElement('div');

          wrapper.className =
            'strict-compact-quantity';

          const label =
            document.createElement('label');

          label.className =
            'strict-compact-quantity__label';

          label.htmlFor =
            `${form.id}-quantity`;

          label.textContent = 'Quantity';

          const control =
            document.createElement('div');

          control.className =
            'strict-compact-quantity__control';

          const minus =
            document.createElement('button');

          minus.type = 'button';
          minus.className =
            'strict-compact-quantity__button';
          minus.dataset.strictQuantityButton = 'minus';
          minus.setAttribute(
            'aria-label',
            'Decrease quantity'
          );
          minus.textContent = '−';

          const input =
            document.createElement('input');

          input.id = `${form.id}-quantity`;
          input.className =
            'strict-compact-quantity__input';
          input.type = 'number';
          input.name = 'quantity';
          input.min = '1';
          input.step = '1';
          input.value = '1';
          input.setAttribute('inputmode', 'numeric');
          input.setAttribute('form', form.id);

          const plus =
            document.createElement('button');

          plus.type = 'button';
          plus.className =
            'strict-compact-quantity__button';
          plus.dataset.strictQuantityButton = 'plus';
          plus.setAttribute(
            'aria-label',
            'Increase quantity'
          );
          plus.textContent = '+';

          control.append(minus, input, plus);
          wrapper.append(label, control);

          return wrapper;
        }

        onFallbackQuantityClick(event) {
          const button = event.target.closest(
            '[data-strict-quantity-button]'
          );

          if (!button) return;

          const control = button.closest(
            '.strict-compact-quantity__control'
          );

          const input = control?.querySelector(
            '.strict-compact-quantity__input'
          );

          if (!input) return;

          const minimum =
            Number.parseInt(input.min || '1', 10);

          const maximum = input.max
            ? Number.parseInt(input.max, 10)
            : Number.POSITIVE_INFINITY;

          const current =
            Number.parseInt(
              input.value || String(minimum),
              10
            );

          const next =
            button.dataset.strictQuantityButton === 'plus'
              ? Math.min(maximum, current + 1)
              : Math.max(minimum, current - 1);

          input.value = String(next);

          input.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      }
    );
  }
})();
